// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue-select/dist/vue-select.css
// module id = 17
// module chunks = 1